import React, { FC, memo, useState } from 'react';
import { useRequest } from 'ahooks';
import { Select, Spin } from 'udesk-ui';
import { SelectProps } from 'udesk-ui/lib/select';
import { getAiAgentConfigsCozeAgents } from 'src/api/aiAgentConfigs/coze/agents';

interface TemplateProps extends SelectProps<string> {
    workspaceId?: string;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { workspaceId, ...restProps } = props;

    const [options, setOptions] = useState<TemplateProps['options']>();

    const { loading } = useRequest(
        () => getAiAgentConfigsCozeAgents({ params: { workspaceId: workspaceId! } }),
        {
            ready: !!workspaceId,
            refreshDeps: [workspaceId],
            onSuccess: (res) => {
                setOptions(res.data?.map((d) => ({ value: d.bot_id!, label: d.bot_name! })) || []);
            },
        }
    );

    return (
        <Select
            options={options}
            style={{ width: 200 }}
            dropdownRender={(menu) => <Spin spinning={loading}>{menu}</Spin>}
            {...restProps}
        />
    );
});

export default Template;
